export default Object.freeze([
  {
    text: 'Домашнее насилие',
    value: '0',
  },
  {
    text: 'Сексуальное насилие',
    value: '1',
  },
  {
    text: 'Принуждение к браку',
    value: '2',
  },
  {
    text: 'Торговля людьми',
    value: '3',
  },
  {
    text: 'Развод',
    value: '4',
  },
  {
    text: 'Другое',
    value: '5',
  },
])
